import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';

@Component({
  selector: 'app-file-manager',
  standalone: false,
  templateUrl: './file-manager.component.html'
})
export class FileManagerComponent {

  @Output() selectedFiles = new EventEmitter<any[]>();
  @Output() deletedFilesList = new EventEmitter<any[]>();

  @Input() type: string = 'file'; // video
  @Input() files: any = [];
  @Input() docsEditable = true;
  @Input() maxFiles = 5;
  @Input() maxFileSize = 10;
  @Input() maxDuration!: number;
  @Input() managerIndex: any = '0'; // For input id multi file manager in one view
  @Input() isRequired = false;
  @Input() isSubmitted = false;
  @Input() isDisabled = false;
  @Input() isViewer = false;
  @Input() cols = 1;
  @Input() hint!: string;
  @Input() differentStyle = false;

  @Input() allowedExt: any[] = [
    'pdf',
    'jpeg',
    'jpg',
    'png',
    'doc',
    'docx',
    'wpd',
    'tex',
    'ppt',
    'pptx',
    'xlsx',
    'xls',
    'zip',
    'rar',
  ];
  allowedExtText = '';

  @Input() renderBtn = false;
  // Uploader
  @Input() isUploader = false;
  @Input() uploadPath!: string;
  @Input() uplodaerType = 0;
  loading = false;
  uploadedFilesArr: any = [];
  @Output() uploadLoaing = new EventEmitter<boolean>();

  /////
  selectedfilesCount = 0;
  deletedFiles: any = [];
  validFile = true;
  fileMaxSiZeErorr = false;
  fileMaxNameSiZeErorr = false;
  fileMaxDurationErorr = false;

  constructor(
    private service: ApiServiceService
  ) { }

  ngOnInit() {
    // if (this.files.length && this.isUploader) {
    //   this.files.forEach((file: any) => {
    //     this.uploadedFilesArr.push(file);
    //   });
    //   this.selectedFiles.emit(this.uploadedFilesArr);
    // }
    this.allowedExtText = this.allowedExt.join(", ");
  }

  /**
   * on file drop handler
   */
  onFileDropped($event: any) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event: any) {
    this.prepareFilesList(event.target.files);
    event.target.value = '';
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number, id: any) {
    if (id) {
      this.deletedFiles.push(id);
    }

    const deleted = this.files[index];
    this.files.splice(index, 1);

    if (this.isUploader) {
      const deletedIndx = this.uploadedFilesArr.findIndex((item: any) => item.fileUpload === deleted.path);
      this.uploadedFilesArr.splice(deletedIndx, 1);
      this.selectedFiles.emit(this.uploadedFilesArr);
    } else {
      this.selectedFiles.emit(this.files);
      this.deletedFilesList.emit(this.deletedFiles);
    }
    this.selectedfilesCount = this.files.length;
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  async prepareFilesList(files: Array<any>) {
    const filesToUpload = [];
    this.validFile = true;
    // this.selectedfilesCount = this.files.length + files.length;
    this.selectedfilesCount = (this.files?.length || 0) + ((files && (files as any).length) || 0);

    if (this.selectedfilesCount > this.maxFiles) {
      return;
    }

    for (const item of files) {
      this.validFile = this.validFileType(item.name);
      this.fileMaxSiZeErorr = false;
      this.fileMaxDurationErorr = false;

      // File size Validation
      if ((item.size / (1024 * 1024)) > this.maxFileSize) {
        this.fileMaxSiZeErorr = true;
      }

      // Video Duration Validation
      if (this.maxDuration && this.type == 'video') {
        const video = document.createElement('video');
        video.preload = 'metadata'; // Important for getting metadata
        video.src = URL.createObjectURL(item);

        await new Promise<void>((resolve) => {
          video.onloadedmetadata = () => {
            URL.revokeObjectURL(video.src); // Clean up object URL
            if (video.duration > this.maxDuration) {
              this.fileMaxDurationErorr = true;
            }
            resolve();
          };
        });
      }

      // Check file and push to array files
      if (this.validFile && !this.fileMaxSiZeErorr && !this.fileMaxDurationErorr) {
        item.fileType = this.fileExt(item.name);
        if (this.isUploader) {
          filesToUpload.push(item);
          this.uploadFile(filesToUpload);
        } else {
          this.files.push(item);
          this.selectedFiles.emit(this.files);
        }
      }
    }
  }

  validFileType(fileName: string) {
    const extension = fileName.split('.').pop()?.toLowerCase();
    const extensionUpper = fileName.split('.').pop()?.toUpperCase();

    if (!(this.allowedExt.includes(extension) || this.allowedExt.includes(extensionUpper))) {
      return false;
    }
    return true;
  }
  fileExt(fileName: string) {
    const extension = fileName?.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'mp4':
        return 'mp4';
      case 'mov':
        return 'mov';
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      case 'pdf':
        return 'pdf';
      case 'doc':
      case 'wpd':
        return 'doc';
      case 'docx':
        return 'docx';
      case 'tex':
      case 'text':
        return 'txt';

      // case 'xlsx':
      // case 'xls':
      //   return 'xls';
      // case 'zip':
      // case 'rar':
      //   return 'zip';
      // case 'ppt':
      // case 'pptx':
      //   return 'pptx';
      default:
        return false;
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  uploadFile(files: any) {
    files.forEach((file: any) => {
      this.uploadLoaing.emit(true);
      this.loading = true;
      this.isDisabled = true;
      this.service.uploadFile(file, this.uploadPath).subscribe(
        (response) => {
          this.uploadLoaing.emit(false);
          this.loading = false;
          this.isDisabled = false;
          let file = {
            name: response.data.orginalFileName,
            path: response.data.fileName,
            size: response.data.size
          }
          this.selectedFiles.emit([file]);
        },
        (err) => {
          this.uploadLoaing.emit(false);
          this.loading = false;
          this.isDisabled = false;
        }
      );
    });
  }
}
